import React, { useEffect, useState } from 'react';
import MLDialog from '../../MLDialog/MLDialog';
import OverLabledTextBox from '../../OverLabledTextBox/OverLabledTextBox';
import { extractSettingAs } from '@macmillan-learning/gradebook-shared';
import MLButton from '../../MLButton';

import s from './StudentIDs.module.css';

const StudentIDs = ({
  gradebookSettings,
  isOpen,
  handleClose,
  handleSubmit,
  isEditingStudentId,
  disableEnforceFocus,
}) => {
  const [idName, setIdName] = useState('');
  const [exampleValue, setExampleValue] = useState('');
  const [value, setValue] = useState('');

  useEffect(() => {
    const newIdName = extractSettingAs(
      gradebookSettings,
      'studentIdCalled',
      ({ value }) => value,
    );
    const newExampleValue = extractSettingAs(
      gradebookSettings,
      'exampleId',
      ({ value }) => value,
    );

    setIdName(newIdName);
    setExampleValue(newExampleValue);
  }, [gradebookSettings]);

  const isValueEmpty = value.length === 0;

  return (
    <MLDialog
      className={s.studentBranding}
      isRequired={!isEditingStudentId}
      title="Student ID Input"
      show={isOpen}
      onClose={handleClose}
      disableEnforceFocus={disableEnforceFocus}
    >
      <div className={s.section}>
        <div className={s.studentIdWhen}>
          Your instructor has required that students enter their <b>{idName}</b>
          , enter it below. If you need to edit your student ID, you can do so
          from your gradebook.
        </div>
        <OverLabledTextBox
          overLabelTxt={`Enter your ${idName}`}
          placeholder={exampleValue}
          overLabelClassName={s.subTitle}
          textFieldClassName={s.textOverTextBox}
          textFieldContainerClassName={s.textOverTextBoxContainer}
          onChange={(_e, id) => setValue(id)}
        />
      </div>
      <div className={`${s.section} ${s.sectionRight}`}>
        <MLButton
          btnType="primary"
          testId="btn_save"
          disabled={isValueEmpty}
          onClick={() => {
            handleSubmit(value);
            handleClose();
          }}
        >
          <span>Save</span>
        </MLButton>
      </div>
    </MLDialog>
  );
};

export default StudentIDs;
